import React, { createContext, useEffect, useState } from 'react'
import Loader from 'components/UI/Loader/Loader'
import TeacherHistoryCard from './components/TeacherHistoryCard'
import { superAxiosRequest } from 'axiosApi'
import styles from './TeachersHistory.module.scss'
import { translate as loc, dict } from 'Localisation'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import { useHistory } from 'react-router-dom'
import useLocalization from 'hooks/useLocalization'
import SearchBooks from 'components/Modules/Ebook/Books/components/SearchBooks/SearchBooks'
import AsideFilter from 'components/UI/AsideFilter/AsideFilter'
import { observer } from 'mobx-react'
import SlotColorTypesNew from '../components/SlotColorTypesNew/SlotColorTypesNew'
import PageHeader from 'components/UI/PageHeader/PageHeader'

export const TeachersHistoryModalContext = createContext('as')

function TeachersHistory() {
  const [companies, setCompanies] = useState([])
  const [locations, setLocations] = useState([])
  const [selectedCompany, setSelectedCompany] = useState(null)
  const [selectedLocation, setSelectedLocation] = useState(null)

  const [allTeachers, setAllTeachers] = useState([])
  const [selectedTeachers, setSelectedTeachers] = useState([])
  const [teachers, setTeachers] = useState([])
  const [typesColors, setTypesColors] = useState([])

  const [isEmpty, setIsEmpty] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isCompaniesLoading, setIsCompaniesLoading] = useState(true)
  const [slotTypesArray, setSlotTypesArray] = useState()

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'all_groups',
    dict: {
      filter: 'Filter',
      search: 'Search',
      start_date: 'Start Date',
      end_date: 'End Date',
      reset_all: 'Reset All',
      apply: 'Apply',
      deal_history: 'Deal History',
      date_of_creation: 'Date of creation',
      search_by_employee: 'Search by employee',
      status: 'Status',
      status_successfully: 'Successfully',
    },
  })

  const [filter, updateFilter] = useLocalStorageFilter()
  const history = useHistory()
  const {
    isOpenFilter,
    closeFilter,
    setTextValues,
    changeTextValue,
    filterTextValues,
  } = AsideFilterStore

  useEffect(() => {
    if (filter?.location && locations.length > 0) {
      const locationObj = locations.find((loc) => loc.value === filter.location)
      setSelectedLocation(locationObj || null)
    } else {
      setSelectedLocation(null)
    }
  }, [filter?.location, locations])

  const handleLocationChange = (locationId) => {
    if (locationId) {
      updateFilter({ ...filter, location: locationId })
    } else {
      const { location, ...newFilter } = filter
      updateFilter(newFilter)
    }
  }

  const filterCfg = [
    {
      type: 'date_day_picker',
      nameState: ['start_date', 'end_date'],
      label: 'Период',
      isRequired: true,
    },
    {
      type: 'select',
      label: 'Локация',
      placeholder: 'Выберите локацию',
      values: locations,
      isSearch: true,
      isRequired: true,
      sort_key: 'label',
      nameState: 'location',
      option_label_key: 'label',
      option_value_key: 'value',
      onRealTimeChange: handleLocationChange,
    },
    {
      type: 'select-multi',
      label: 'Преподаватели',
      placeholder: 'Выберите преподавателей',
      values: allTeachers,
      isSearch: true,
      sort_key: 'name',
      nameState: 'employee_id',
      option_label_key: 'name',
      option_value_key: 'id',
      isRequired: true,
      autoSelectedValues: filter?.employee_id || selectedTeachers,
    },
  ]

  const updateLocations = (company) => {
    const locations = company.locations
      .map((item) => ({
        ...item,
        value: item?.id,
        label: item?.name,
      }))
      .sort((a, b) => (a.label > b.label ? 1 : -1))
    setLocations(locations)
  }

  const handleShowTeachersButton = () => {
    setIsLoading(true)
    setIsEmpty(false)

    const params = {
      ...filter,
      employee_id: [filter?.employee_id],
    }
    if (selectedCompany?.value) {
      params.company = selectedCompany.value
    }

    superAxiosRequest({
      method: 'get',
      link: 'online_schedule/teacher/history',
      params,
    })
      .then(({ data }) => {
        if (data.booked_slots.length === 0) {
          setIsEmpty(true)
        }
        setTeachers(
          data.booked_slots.sort((a, b) =>
            a.employee_name > b.employee_name ? 1 : -1,
          ),
        )
        setTypesColors(
          data.slot_types.map(({ type_id, color, type_name }) => ({
            id: type_id,
            name: type_name,
            color,
          })),
        )
        setSlotTypesArray(
          data.slot_types.map((item) => ({
            id: item.type_id,
            value: item.type_id,
            label: item.type_name,
            name: item.type_name,
          })),
        )
      })
      .catch(() => setIsEmpty(true))
      .finally(() => setIsLoading(false))
  }

  useEffect(() => {
    if (!!filter?.employee_id) {
      handleShowTeachersButton()
    }
  }, [filter])

  const getUpdatedTeachersData = (data) => {
    //меняет статус слота и возврает обновленный teachers
    if (!updatingTeacher) return

    let updatingTeacher = teachers.filter(
      (item) => item?.employee_id === data?.employee_id,
    )[0]
    updatingTeacher = {
      ...updatingTeacher,
      items: [
        {
          ...updatingTeacher?.items[0],
          employee_booked_slots: [
            ...updatingTeacher.items[0]?.employee_booked_slots?.filter(
              (item) => item?.id !== data?.id,
            ),
            {
              ...updatingTeacher.items[0]?.employee_booked_slots?.filter(
                (item) => item?.id === data?.id,
              )[0],
              is_active:
                !updatingTeacher?.items[0]?.employee_booked_slots?.filter(
                  (item) => item?.id === data?.id,
                )[0]?.is_active,
            },
          ].sort((a, b) => {
            let timeArrayA = a?.start_at?.split(':')
            let timeArrayB = b?.start_at?.split(':')
            return new Date().setHours(
              timeArrayA?.[0],
              timeArrayA?.[1],
              timeArrayA?.[2],
              0,
            ) >
              new Date().setHours(
                timeArrayB?.[0],
                timeArrayB?.[1],
                timeArrayB?.[2],
                0,
              )
              ? 1
              : -1
          }),
        },
      ],
    }
    setTeachers(
      [
        ...teachers.filter((item) => item?.employee_id !== data?.employee_id),
        updatingTeacher,
      ].sort((a, b) => (a?.employee_name > b?.employee_name ? 1 : -1)),
    )
  }

  useEffect(() => {
    superAxiosRequest({
      method: 'get',
      link: 'db/companies',
    })
      .then(({ data }) => {
        if (data.result.length === 1) {
          const company = {
            ...data.result[0],
            value: data.result[0].id,
            label: data.result[0].name,
          }
          setSelectedCompany(company)
          updateLocations(company)
        }
        setCompanies(
          data.result
            .map((item) => ({ ...item, value: item.id, label: item.name }))
            .sort((a, b) => (a.label > b.label ? 1 : -1)),
        )
      })
      .finally(() => setIsCompaniesLoading(false))
  }, [])

  useEffect(() => {
    superAxiosRequest({
      method: 'get',
      link: 'accounts/employers_flat_list',
    }).then(({ data }) => {
      setAllTeachers(
        data.result.map(({ id, full_name }) => ({ id, name: full_name })),
      )
    })
  }, [])

  useEffect(() => {
    if (selectedLocation === null) {
      return
    }

    superAxiosRequest({
      method: 'get',
      link: 'accounts/employers_flat_list',
      params: {
        location: selectedLocation.value,
      },
    }).then(({ data }) => {
      const teachersForLocation = data.result.map(({ id, full_name }) => ({
        id,
        name: full_name,
      }))

      setSelectedTeachers(teachersForLocation)
    })
  }, [selectedLocation])

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname !== `/online-schedule-v2/teachers-history`) {
        updateFilter({})
      }
    })
    return () => {
      unlisten()
    }
  }, [history, updateFilter])

  return (
    <>
      <div className={styles.header}>
        <PageHeader title={'История записи сотрудников'}></PageHeader>
        <div className={styles.searchFilterValues}>
          <SearchBooks
            onSearch={(text) => {
              updateFilter({ ...filter, employee: text })
              changeTextValue('employee', {
                key: 'employee',
                label: translate.search,
                value: text,
              })
            }}
            onClear={() => {
              const { search, ...obj } = filter
              updateFilter(obj)
              setTextValues(
                filterTextValues.filter((field) => field.key !== 'search'),
              )
            }}
            translate={translate}
            placeholder={translate.search}
            value={filter?.search || ''}
          />
          {isOpenFilter && (
            <AsideFilter
              getFilterParams={(e) => {
                updateFilter(e)
              }}
              config={filterCfg}
              filterValue={filter}
              onDropFilter={() => {
                updateFilter({})
                // setSelectedLocation(null) // сбрасываем локацию
                closeFilter()
                // setSelectedTeachers(null)
              }}
              translate={translate}
            />
          )}
        </div>
        <SlotColorTypesNew types={typesColors} />
      </div>

      <div className={styles.content}>
        {isEmpty && (
          <div className={styles.empty}>
            За выбранный период нет записей сотрудников
          </div>
        )}

        {teachers.length > 0 && filter?.employee_id && !isLoading && (
          <TeachersHistoryModalContext.Provider
            value={{
              slotTypesArray: slotTypesArray,
              selectedLocation: selectedLocation,
              locationId: selectedLocation?.id || filter?.location,
              getUpdatedTeachersData: getUpdatedTeachersData,
            }}
          >
            <div className={styles.containerTeachers}>
              <div className={styles.teachers_count}>
                Учителей: {teachers.length}
              </div>
              <ul className={styles.teachers_list}>
                {teachers.map((item, index) => (
                  <TeacherHistoryCard
                    key={item.employee_id.toString()}
                    data={item}
                    index={index}
                  />
                ))}
              </ul>
            </div>
          </TeachersHistoryModalContext.Provider>
        )}

        {isLoading && <Loader fullWidth />}
      </div>
    </>
  )
}

export default observer(TeachersHistory)
